import type { ReactNode } from "react";
import type { RouterInputs, RouterOutputs } from "@/trpc";

export type RunScope = Omit<RouterInputs["psv"]["getRun"], "runId">;
export type ListedRun = RouterOutputs["psv"]["listRuns"]["runs"][number];
export type RunSummary = ListedRun["summary"];
export type RunReport = RouterOutputs["psv"]["getRun"];
export type ReportItem = RunReport["items"][number];
export type ItemSummary = RunReport["itemSummary"];
export type StartedRun = RouterOutputs["psv"]["startVerificationRun"];

export type StartVerificationDialogProps = {
  scope: Pick<
    RunScope,
    "organizationBusinessUnitId" | "providerUserId" | "expectedAffiliationId"
  >;
  onClose: () => void;
  onStarted: (run: StartedRun) => Promise<void>;
  onRestoreFocus: () => void;
};
export type RenderStartVerification = (
  props: StartVerificationDialogProps,
) => ReactNode;

export const ACTIVE_RUN_POLL_MS = 3000;

export function isRunActive(run: { status: string } | null | undefined) {
  return run?.status === "queued" || run?.status === "running";
}

export function isRunCancelled(run: { status: string } | null | undefined) {
  return run?.status === "cancelled";
}

export type RenderRunActivity = (input: {
  run: Pick<ListedRun, "status">;
  summary: RunSummary;
  checks?: RunReport["checks"];
  itemSummary: ItemSummary;
}) => {
  badge: ReactNode;
  details: ReactNode;
  label?: string;
  showSourceFindings?: boolean;
} | null;
/** The one check that screens every state Medicaid exclusion list. Its
 * `stateSources` and per-state assessment items drive the state group;
 * every other check leaves `stateSources` empty. */
export const STATE_MEDICAID_EXCLUSIONS_SOURCE_ID = "state-medicaid-exclusions";
